"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Section4_1 = __importDefault(require("./Section4"));
exports.Section4 = Section4_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9pbnRlbGxpdGVjL0Vucm9sbGVtbnRQYWNrZXRJbmZvXzRfNi9wYXJ0cy9TZWN0aW9uNC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHdEQUFpQztBQUN6QixtQkFERCxrQkFBUSxDQUNDIn0=